export default __webpack_public_path__ + "83038f2eba3faa08d4bb64eab73285d4.png";